import React from "react";
import { Zap, ShieldCheck, MapPin } from "lucide-react";
import { LogoMark, Logo } from "@/components/Logo";
import { Link } from "react-router-dom";

const HERO_BG = "https://customer-assets.emergentagent.com/job_ebikego-preview/artifacts/l3hwcv4v_ChatGPT%20Image%20Jun%2030%2C%202026%2C%2009_46_41%20AM.png";

const FEATURES = [
  { icon: Zap, title: "100% Electric", sub: "Zero Emissions" },
  { icon: ShieldCheck, title: "Insured Rides", sub: "Complete Safety" },
  { icon: MapPin, title: "Doorstep Delivery", sub: "Convenient & Fast" },
];

export const AuthHero = ({ accent, heading, sub }) => (
  <div className="hidden lg:flex relative bg-[#0A0B10] text-white flex-col justify-between overflow-hidden">
    {/* Background image - full visible */}
    <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${HERO_BG})` }} />
    {/* Subtle gradient — keeps text readable on the upper-left and bottom strip */}
    <div className="absolute inset-0 bg-gradient-to-r from-[#0A0B10]/65 via-[#0A0B10]/15 to-transparent" />
    <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-[#0A0B10]/90 to-transparent" />

    {/* TOP: Logo */}
    <div className="relative p-10">
      <Link to="/" data-testid="auth-hero-logo">
        <Logo dark height={34} />
      </Link>
    </div>

    {/* MIDDLE: text block left-aligned — wrapper allows heading to breathe, description stays clear of scooter */}
    <div className="relative px-10 -mt-16 max-w-md">
      <p className="font-display font-bold text-2xl md:text-3xl" style={{ color: "#3DDC97" }} data-testid="auth-accent">
        {accent}
      </p>
      <h2 className="font-display font-extrabold text-4xl md:text-5xl mt-3 leading-[1.05] tracking-tight">
        {heading}
      </h2>
      <p className="text-white/75 mt-5 text-sm leading-relaxed max-w-[260px]">
        {sub}
      </p>
    </div>

    {/* BOTTOM: feature pills */}
    <div className="relative p-10 pb-8">
      <div className="grid grid-cols-3 gap-4 max-w-md">
        {FEATURES.map((f, i) => (
          <div key={i} className="flex flex-col items-start" data-testid={`auth-feature-${i}`}>
            <div className="w-10 h-10 rounded-full bg-white/8 border border-[#3DDC97]/40 flex items-center justify-center mb-3">
              <f.icon size={16} className="text-[#3DDC97]" />
            </div>
            <p className="font-display font-bold text-sm text-white leading-tight">{f.title}</p>
            <p className="text-[11px] text-white/55 mt-0.5">{f.sub}</p>
          </div>
        ))}
      </div>

      <div className="flex items-center gap-2 mt-8 text-[11px] text-white/40 font-mono-num">
        <LogoMark size={16} />
        <span>THINK EBIKEGO PRIVATE LIMITED · 2026</span>
      </div>
    </div>
  </div>
);
